// ─────────────────────────────────────────────────────────────────────────────
// ALL SITE DETAILS LIVE HERE — replace the [bracketed] values with your real
// information and every page, the footer and the favicon caption update at once.
// Just send them in chat as: Name / Credentials / Registrations / City /
// Address / Hours / Email / Phone
// ─────────────────────────────────────────────────────────────────────────────

export const PRACTICE = {
  name: "Ioannis Tsiros",
  fullName: "Ioannis Tsiros — Psychotherapy",
  tagline: "Individual Psychotherapy",
  description:
    "A private psychotherapy practice offering warm, unhurried individual therapy online.",
};

export const THERAPIST = {
  name: "Ioannis Tsiros",
  credentials: "MBACP",
  city: "Athens",
  email: "info@ioannistsiros.com",
  phone: "+30 698 205 2345",
  registrations: [
    { body: "BACP — British Association for Counselling & Psychotherapy", ref: "United Kingdom · Registration 420016" },
    { body: "Licensed Psychologist", ref: "Greece · Registration 274123" },
  ],
};

export const REASON_OPTIONS = [
  "Anxiety & overwhelm",
  "Low mood & depression",
  "Relationships",
  "Work & burnout",
  "Grief & loss",
  "Life transitions",
  "Self-esteem",
  "Feeling stuck",
  "Other",
];

export const SUPPORT_TYPE_OPTIONS = [
  { value: "individual", label: "Individual therapy (open-ended)" },
  { value: "short-term", label: "Short-term consultation" },
  { value: "unsure", label: "Not sure yet" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1754037783933-c25ff9f68f87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  abstract:
    "https://images.unsplash.com/photo-1760104544730-e7366adba8d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  portrait:
    "https://images.unsplash.com/photo-1714976694867-bc0e012fab70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  office:
    "https://images.unsplash.com/photo-1604328698692-f76ea9498e76?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  detail:
    "https://images.unsplash.com/photo-1612196808827-9ff25cb6137a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const MARQUEE_ITEMS = [
  "Post-existential",
  "Relational care",
  "A safe space",
  "Individual focus",
  "Unhurried time",
];
